import { Component, inject, signal } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ThemeService } from '../../../core/services/config/theme.service';

/**
 * Interruptor de tema claro/oscuro.
 *
 * Se monta una sola vez desde `AppComponent`, flotando arriba a la derecha:
 * las cabeceras de pantalla (`<header class="header fixed-header">`) estan
 * repetidas en cada vista, asi que meterlo "dentro del header" habria sido
 * el mismo boton copiado veinte veces y con veinte formas de desincronizarse.
 */
@Component({
  selector: 'app-theme-toggle',
  standalone: true,
  imports: [],
  templateUrl: './theme-toggle.component.html',
  styleUrl: './theme-toggle.component.scss',
})
export class ThemeToggleComponent {
  private readonly router = inject(Router);

  readonly theme = inject(ThemeService);

  /**
   * En el visor no se muestra.
   *
   * Los visores tienen su propia paleta oscura (`viewer-styles.scss`), que
   * no cambia con el tema de la app, y ademas su esquina superior derecha ya
   * esta ocupada por el enlace "Escritorio"/"Version movil": el boton
   * quedaba encima tapandolo.
   */
  readonly visible = signal(!this.esVisor(this.router.url));

  constructor() {
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e) => this.visible.set(!this.esVisor(e.urlAfterRedirects)));
  }

  private esVisor(url: string): boolean {
    return url.startsWith('/viewer');
  }

  get etiqueta(): string {
    return this.theme.esOscuro() ? 'Cambiar a tema claro' : 'Cambiar a tema oscuro';
  }
}
